/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteButtonBase } from "./d-theme-white-button-base";

export class DThemeWhiteButtonSecondary<VALUE = unknown> extends DThemeWhiteButtonBase<VALUE> {}
